import { render, staticRenderFns } from "./TimeExpired.vue?vue&type=template&id=1b0763b4"
import script from "./TimeExpired.vue?vue&type=script&lang=js"
export * from "./TimeExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports